// NOTE: Placeholder legal copy. Final legal language to be drafted by Eric; lawyer review pending.
// Do not render any "draft" watermark to users.
import React from 'react';

/**
 * Shared Affiliate Program Terms & Conditions body.
 * Rendered both on the standalone /legal/affiliate-terms page and inside the
 * Settings affiliate enrollment modal. Styling comes from the parent context
 * (e.g. .legal-content on the standalone page).
 */
const AffiliateTermsContent = () => {
  return (
    <div className="affil-terms-content">
      <p>
        <strong>Version:</strong> 1.0
      </p>

      <p>The TradeMagic Partner Program is an affiliate referral program.</p>

      <p>
        These Partner Program Terms &amp; Conditions (&quot;Partner Terms&quot;) govern
        participation in the TradeMagic Partner Program (the &quot;Program&quot;), operated by
        Gifts From The Nine, LLC (&quot;TradeMagic,&quot; &quot;we,&quot; &quot;us,&quot; or
        &quot;our&quot;). By enrolling in the Program, you agree to these Partner Terms in
        addition to the TradeMagic <a href="/terms">Terms of Service</a>.
      </p>

      <h2>1. Commissions</h2>
      <ul>
        <li>You earn $5 USD for each verified Elite conversion attributed to your referral link.</li>
        <li>
          A commission is earned only for a referred user&apos;s FIRST Elite subscription. If a
          referred user cancels their Elite subscription and later re-subscribes, the
          re-subscription does not generate a second commission.
        </li>
      </ul>

      <h2>2. Payouts</h2>
      <ul>
        <li>Payouts are processed monthly via PayPal.</li>
      </ul>

      <h2>3. Refunds and Disputes</h2>
      <ul>
        <li>
          Earnings are voided if the referred subscription is refunded or disputed before the
          payout is processed.
        </li>
      </ul>

      <h2>4. Self-Referrals</h2>
      <ul>
        <li>
          Self-referrals are prohibited and are automatically blocked. You cannot earn a
          commission by subscribing to Elite through your own referral link.
        </li>
      </ul>

      <h2>5. Fraud and Abuse</h2>
      <ul>
        <li>
          TradeMagic reserves the right to withhold payouts for suspected fraud or abuse. If a
          payout is withheld, the partner will be notified by email.
        </li>
      </ul>

      <h2>6. Program Changes and Termination</h2>
      <ul>
        <li>
          TradeMagic reserves the right to modify or terminate the Program at any time with 30
          days notice via email.
        </li>
      </ul>

      <h2>7. Taxes</h2>
      <ul>
        <li>
          Partners are responsible for their own tax reporting obligations. TradeMagic does
          not issue 1099s.
        </li>
      </ul>

      <h2>8. Account Standing</h2>
      <ul>
        <li>
          Accounts that are banned or suspended forfeit all pending and eligible earnings.
        </li>
      </ul>

      <h2>9. Username Changes</h2>
      <ul>
        <li>
          Referral links are based on your username. If you change your username, previously
          shared referral links that use your old username stop attributing referrals to your
          account.
        </li>
      </ul>
    </div>
  );
};

export default AffiliateTermsContent;
